module.exports = __webpack_public_path__ + "static/img/SavePolesia_logo-RU.32a607e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logotype/SavePolesia_logo-RU.png
// module id = 103
// module chunks = 0